import {
  useGetAllTransactions,
  useGetManagementTransactions,
} from "../../../hooks/queries/useTransactionQueries";

export const useTransactionData = ({
  apiFilters,
  managementApiFilters,
  isSuperAdmin,
}) => {
  const regularQuery = useGetAllTransactions(apiFilters, {
    enabled: !isSuperAdmin,
  });
  const managementQuery = useGetManagementTransactions(managementApiFilters, {
    enabled: isSuperAdmin,
  });
  const {
    data: transactionResponse = {},
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = isSuperAdmin ? managementQuery : regularQuery;

  const transactions = transactionResponse.content || [];

  return {
    transactions,
    totalElements: transactionResponse.totalElements || 0,
    totalPages: transactionResponse.totalPages || 0,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    noTransactions: transactions.length === 0,
  };
};

export default useTransactionData;
